import { APP_ROOT_PATH } from '../../constants/url';

const MLP_BASE = '/mobilelogin';

class MLPServiceClient {
    static GATEKEEPER = `${MLP_BASE}/gatekeeper`;

    static LOGOUT =
        `${MLP_BASE}/logout?user_type=student&redirect=/${APP_ROOT_PATH}/`;

    static MAS_TOKEN =
        `${MLP_BASE}/mas_token`;
}

export default MLPServiceClient;
